import React, { useEffect, useRef, useState } from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import PersonIcon from "@material-ui/icons/Person"
import { FacebookIcon } from "react-share"

const Header = ({ siteTitle, menuItems }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          adminUrl
        }
      }
    }
  `)
  const [isSticky, setSticky] = useState(false)
  const ref = useRef(null)
  const handleScroll = () => {
    if (ref.current) {
      setSticky(ref.current.getBoundingClientRect().top <= 0)
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", () => handleScroll)
    }
  }, [])
  return (
    <header className="header">
      <div className="header--top bg-dark">
        <div className="grid-container">
          <div className="header--top--container">
            <Link className="logo" to="/">
              MPDJ
            </Link>
            <div className="header--top--right-container">
              <a
                className="header--social"
                href="https://www.facebook.com/jediwebdesigner"
                target="_blank"
                rel="noreferrer"
                aria-label="Suivez-nous"
              >
                <FacebookIcon size="2.5em" />
              </a>
              <Link
                className="header--top--link"
                to={data.site.siteMetadata.adminUrl}
                target="_blank"
                rel="noreferrer"
              >
                <PersonIcon />
                <div className="show-for-medium">Connection pro</div>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className={`sticky-wrapper${isSticky ? " sticky" : ""}`} ref={ref}>
        <div className="sticky-inner">
          <nav className="bg-primary">
            <div className="grid-container">
              <ul className="header--nav-list">
                <li key="accueil">
                  <Link
                    className="header--nav-item"
                    activeClassName="header--nav-item__active"
                    to="/"
                  >
                    Accueil
                  </Link>
                </li>
                {menuItems.map(item => {
                  return (
                    <li key={item.id}>
                      <Link
                        className="header--nav-item"
                        activeClassName="header--nav-item__active"
                        to={item.url}
                      >
                        {item.label}
                      </Link>
                    </li>
                  )
                })}
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Header
